import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { getActivityCounts } from "../../redux/actions/MlTrackLibraryActions";
import { trackActivityType } from "redux/Types";

class activityCounts extends Component {
  componentDidMount() {
    this.getActivityResult();
  }

  componentDidUpdate(prevProps) {
    const {
      data: { selectedItem },
    } = this.props;
    if (prevProps?.data?.selectedItem?.id !== selectedItem?.id) {
      this.getActivityResult();
    }
  }

  getActivityResult() {
    const {
      data: { selectedItem },
      getActivityCounts,
    } = this.props;
    if (selectedItem && selectedItem.id) {
      const ids = [selectedItem.id];
      const types = [trackActivityType.STREAM, trackActivityType.DOWNLOAD];
      getActivityCounts(ids, types);
    }
  }

  render() {
    const {
      id,
      data: { trackActivityCounts },
    } = this.props;

    return (
      <span>
        {id === trackActivityType.STREAM
          ? trackActivityCounts.streams || 0
          : trackActivityCounts.downloads || 0}
      </span>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mltracklibrary,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  getActivityCounts,
})(withStyles()(activityCounts));
